import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError";

export function useQuestionnaireSortingQuery({ orgID, getAllAuthorized, isDefault, onSuccess, ...props }) {
    const fetch = () => {
        if(getAllAuthorized === true){
            return axios.get(`/questionnaire?purpose=questionnaire&orgId=${orgID}&getAllAuthorized=${getAllAuthorized}&isDefault=${isDefault}`);
        } else {
            return axios.get(orgID == 'All' ? "/questionnaire?purpose=questionnaire" : `questionnaire?purpose=questionnaire&orgId=${orgID}`);
        }
    }
    const query = useQuery(
        ["questionnaires-sorting-list",orgID],
        fetch,
        {   
            enabled: !!orgID,
            select: (data) => data.data,
            onError,
            onSuccess,
            ...props
        }
    );
    return { ...query };
}
